module.exports = __webpack_public_path__ + "img/sse.d23c7e17.jpg";